import { x as o } from "../../../lit-element-6iugfgmM.js";
class n {
  constructor(r) {
    this.id = r;
  }
  renderIcon() {
    return o``;
  }
  renderDialog(r) {
  }
}
export {
  n as Option
};
//# sourceMappingURL=Option.js.map
